<template>
	<v-card>
    <div v-for='slug in slugs'>
      <v-chip color='blue-grey lighten-5'>
    <v-avatar
    size='16px'>
     <img :src='iconURLs[slug.icon]'>
    </img>
   </v-avatar>
          {{slug.name}}
  </v-chip>
    <v-btn :href='slug.downloadURL'>
      Download
    </v-btn>
  </div>
  </v-card>
</template>
<script>
	import {firestore, db} from '@/firebase/firebase.js'
import {mapGetters} from 'vuex'
	export default {
  props: ['channelID', 'projectid'],
  data () {
    return {
      downloadURL: '',
      iconURLs: {}
    }
  },
  mounted () {
    // let storageRef = firestore.ref('/' + this.projectid + '/' + this.project.components[this.channelID].ref)
    let storageRef = firestore.ref('/Valencia/shapefiles/county.zip')
    var that = this
    storageRef.getDownloadURL().then(function (url) {
      that.downloadURL = url
    })
  },
  methods: {
    populateURLs: function () {
      for (let inx in this.slugs) {
        let storageRef = firestore.ref('/' + this.projectid + '/' + this.slugs[inx].ref)
        let iconRef = firestore.ref(this.slugs[inx].icon)
        let that = this
        storageRef.getDownloadURL().then(function (url) {
          that.slugs[inx]['downloadURL'] = url
        })
        iconRef.getDownloadURL().then(function (url) {
          that.$set(that.iconURLs, that.slugs[inx].icon, url)
        })
      }
    }
  },
  computed: {
    ...mapGetters('project', {
      project: 'selectedProject'
    })
  },
  firebase: function () {
    return {
      slugs: {
        source: db.ref('projects/' + this.projectid + '/data/' + this.project.components[this.channelID].data),
        readyCallback: function () {
          this.populateURLs()
        }

      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/project/DataSlug.vue